export const isIosEnv = import.meta.env.VITE_IOS === "true";

export const isMobileApp = import.meta.env.VITE_MOBILE === "true";
